const toDate = (v) => new Date(typeof v === 'string' && !/[zZ]|[+-]\d\d:?\d\d$/.test(v) ? `${v}Z` : v);

export const ptDate = (v) => (v ? toDate(v).toLocaleDateString('pt-PT', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '—');

export const daysLeft = (v) => Math.max(0, Math.ceil((toDate(v) - Date.now()) / 86400000));

export const addDays = (d, n) => new Date(d.getTime() + n * 86400000);
